module.exports = __webpack_public_path__ + "img/gmdl_icon4.6465c477.png";